






















































// @ts-nocheck
import { Component, Vue, Watch } from 'vue-property-decorator'
import { DataStore, SortDirection, Hub } from 'aws-amplify'
import { query as tenant } from '@/store/tenant'
import { District, Checklist, ChecklistItem, Info } from '../models/index'

@Component<ChecklistsSideBar>({
  apollo: {
    tenant
  }
})
export default class ChecklistsSideBar extends Vue {
  districts = []
  districtsSubscription = null
  checklists = []
  checklistsSubscription = null
  infos = []
  infosSubscription = null

  get districtId() {
    return this.$route.params.districtId
  }

  get districtsSelectOptions() {
    return this.districts.map(district => ({
      text: district.name.de,
      value: district.id
    }))
  }

  @Watch('tenant')
  async recreate() {
    this.subscribeToDataStore();
  }

  subscribeToDataStore() {
    if (!this.tenant) return;
    this.subscribeToDistricts()
    this.subscribeToChecklists()
    this.subscribeToInfos()
  }

  subscribeToDistricts() {
    this.districtsSubscription !== null && this.districtsSubscription.unsubscribe()
    this.districtsSubscription = DataStore.observeQuery(
      District,
      p => p.tenant.eq(this.tenant.id),
    ).subscribe(({ items }) => {
      items.sort(function(a, b){
        if(a.name.de < b.name.de) { return -1; }
        if(a.name.de > b.name.de) { return 1; }
        return 0;
      })
      this.districts = Array.from(items)
    })
  }

  subscribeToChecklists() {
    this.checklistsSubscription !== null && this.checklistsSubscription.unsubscribe()
    this.checklistsSubscription = DataStore.observeQuery(
      Checklist,
      p => p.and(p => [
        p.tenant.eq(this.tenant.id),
        p.districtID.eq(this.districtId),
      ]),
      {
        sort: s => s.sortPosition(SortDirection.ASCENDING)
      }
    ).subscribe(async ({ items }) => {
      this.checklists =  Array.from(await Promise.all(
        items.map(async i => ({
          ...i,
          items: await DataStore.query(
            ChecklistItem,
            p => p.checklistID.eq(i.id),
            {
              sort: s => s.sortPosition(SortDirection.ASCENDING)
            }
          )
        }))
      ))
    })
  }

  subscribeToInfos() {
    this.infosSubscription !== null && this.infosSubscription.unsubscribe()
    this.infosSubscription = DataStore.observeQuery(
      Info,
      p => p.and(p => [
        p.tenant.eq(this.tenant.id),
        p.districtID.eq(this.districtId),
      ]),
      {
        sort: s => s.sortPosition(SortDirection.ASCENDING)
      }
    ).subscribe(({ items }) => {
      this.infos = Array.from(items)
    })
  }

  created() {
    this.subscribeToDataStore();
    Hub.listen('ListEdit', ({ payload }) => {
      if (payload.data?.model === "Checklist") {
        this.subscribeToChecklists()
      }
      if (payload.data?.model === "Info") {
        this.subscribeToInfos()
      }
    })
  }

  destroyed() {
    this.districtsSubscription.unsubscribe()
    this.checklistsSubscription.unsubscribe()
    this.infosSubscription.unsubscribe()
    Hub.remove('ListEdit', () => {})
  }

  @Watch('districtId')
  refetchPage() {
    this.subscribeToChecklists()
    this.subscribeToInfos()
  }

  changeDistrict(districtId: string) {
    this.$router.push({ name: 'district-checklists', params: { districtId } })
  }

  routeToChecklist(checklist: any) {
    this.$router.push({
      name: 'district-checklist-edit',
      params: { districtId: this.districtId, checklistId: checklist.id }
    })
  }
}
